<template>
  <div>
    <div
      class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
    >
      <div>
                <router-link :to="{ path: '/information-banks-page'}">
          <button type="submit" class="btn btn-info  btn-sm mr-2 px-2">Bilgi Bankası</button>
        </router-link>
        <router-link :to="{ path: '/information-banks-content'}">
          <button type="submit" class="btn btn-danger active btn-sm  px-2 mr-2">İçerik</button>
        </router-link>

      </div>
      <span></span>
    </div>
    <card>
      <form class="w-100" @submit="submit">
        <div v-if="!err">

        <h1 class="h4 mt-0 d-flex justify-content-between">
          <span>Bilgi Bankası İçerik</span>

          <button type="submit" class="btn btn-info btn-sm btn-fill">Kaydet</button>
        </h1>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex flex-column">
              <label :for="settings.name">
                <span class="title">{{settings.meta.title}}</span>
              </label>
              <tinymce id="d1" v-model="settings.data" style="width: 100%" :other_options="options"></tinymce>
            </div>
          </div>
        </div>
        </div>
<div v-if="err">
  {{err}}
</div>
      </form>
    </card>
  </div>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";
import Checkbox from "src/components/UIComponents/Inputs/Checkbox.vue";
export default {
  data: function() {
    return {
      settings: {
        name: null,
        meta: {
          title: null
        },
        data: null
      },
      imageIndex: -1,
      image: {
        cropped: null
      },
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      },
      err:null
    };
  },
  components: {
    Checkbox,
    Card
  },
  methods: {
    getSettings: function() {
      this.toggleLoader();
      this.$http.get("/api/settings/get-information-banks/").then(
        response => {
          this.settings = response.body;
          this.settings.meta = JSON.parse(this.settings.meta);

          // for (var i = 0; i < this.settings.length; i++) {
          //   this.settings[i].meta = JSON.parse(this.settings[i].meta);
          // }

          this.toggleLoader();
        },
        er => {
                     if(!er.body.Error){
             this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            }else{
              this.err = er.body.Error;
            this.notifier(
              'top',
              'right',
              'danger',
              er.body.Error
              )
            }
            this.toggleLoader();
        }
      );
    },
    submit: function() {
      event.preventDefault();
      this.$http.post("/api/settings/update-one/", this.settings).then(
        response => {
          this.notifier("top", "right", "success", "Başarıyla güncellendi");
          this.getSettings();
        },
        e => {
                                          if(!e.body.Error){
            this.notifier(
              "top",
              "right",
              "danger",
              "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
            );
            }else{
            this.notifier(
              "top",
              "right",
              "danger",
              e.body.Error
            );
            }
        }
      );
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getSettings();
    });
  }
};
</script>
<style>
.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  background-color: #007bff !important;
}
.nav-pills:focus {
  outline: none;
}
.nav-pills a {
  color: #000;
}

.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  color: #fff;
}
.nav-item {
  margin-bottom: 5px;
}
.menu-item:hover {
  cursor: move;
}
.panel-map {
  width: 100%;
  height: 2.7rem !important;
  margin-bottom: 1rem;
}
label .title {
  text-transform: capitalize;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/InformationBanksContentModules/Index.vue